import { NgModule } from '@angular/core';
import {ApiResourceModule} from "../../apiResource/apiResource.module";
import {UrlHelperModule} from "../../url-helper/url-helper.module";
import {AirServicesResourceService} from "./air-services-resource.service";



@NgModule({
    imports: [
        ApiResourceModule,
        UrlHelperModule,
    ],
    providers: [
        AirServicesResourceService,
    ]
})
export class AirServicesResourceModule { }
